import { render, staticRenderFns } from "./PerformanceManagerCard.vue?vue&type=template&id=448f0236&"
import script from "./PerformanceManagerCard.vue?vue&type=script&lang=ts&"
export * from "./PerformanceManagerCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports